module.exports = __webpack_public_path__ + "static/media/05_BischofOverbeck_webfinal.8beb72b0.jpg";